import { api } from '@goaltree/backend/convex/_generated/api'
import type { Id } from '@goaltree/backend/convex/_generated/dataModel'
import { useMutation } from 'convex/react'

import { markReplanPending } from '@/lib/goals-optimistic'
import { handleUsageLimit } from '@/lib/usage-limit'

export function useReplanGoal() {
  const trigger = useMutation(api.replanQueue.triggerReplan).withOptimisticUpdate(
    (store, { goalId }) => markReplanPending(store, goalId),
  )
  return (args: { goalId: Id<'nodes'> }) =>
    trigger(args).catch((err) => {
      if (!handleUsageLimit(err)) throw err
    })
}
